import { Button, Input, Typography } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import "./rolesandpermissions.scss";
import LogModal from "./LogModal";
import DataTableRolesPermission from "../../components/dataTable/DataTableRolesPermission";
import AddEditModal from "./AddEditModal";
import { roleandpermissions } from "../../services";

const { Text } = Typography;

export default function RolesAndPermissions(): JSX.Element {
  const [addEditModal, setAddEditModal] = useState<boolean>(false);
  const [rolesData, setRolesData] = useState<any>([]);
  const [singleData, setSingleData] = useState<any>({});
  const [filteredData, setFilteredData] = useState<any>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");

  const handleEdit = (record: any) => {
    setSingleData(record);
    setAddEditModal(true);
  };

  const getRolespermissionData = useCallback(() => {
    setLoader(true);
    roleandpermissions
      .getAllRoles()
      .then((res: any) => {
        setLoader(false);
        setRolesData(res?.data?.data);
        setFilteredData(res?.data?.data || []);
      })
      .catch((err: any) => {
        setLoader(false);
        setFilteredData([]);
      });
  }, []);

  useEffect(() => {
    getRolespermissionData();
  }, [getRolespermissionData]);

  useEffect(() => {
    if (Array.isArray(rolesData)) {
      const lowercasedQuery = searchText.toLowerCase();
      const filtered = rolesData.filter(
        (item: any) =>
          item.full_name?.toLowerCase().includes(lowercasedQuery) ||
          item.user_type?.toLowerCase().includes(lowercasedQuery) ||
          item.email?.toLowerCase().includes(lowercasedQuery)
      );
      setFilteredData(filtered);
    }
  }, [searchText, rolesData]);

  return (
    <div>
      <div className="rolesPermissions">
        <div className="info">
          <Text className="title24">Roles & Permissions</Text>
          <p>View site collaborators and their assigned roles</p>
        </div>
      </div>
      <div className="filterMenu">
        <Button className="add_button" onClick={() => setAddEditModal(true)}>
          Add New User
        </Button>
        <LogModal />
        <Input.Search
          id="search"
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>
      <DataTableRolesPermission
        rolesData={filteredData || []}
        loader={loader}
        onEdit={handleEdit}
      />
      <AddEditModal
        // refreshLogs={refreshLogsOnSuccess}
        refreshData={getRolespermissionData}
        setSingleData={setSingleData}
        singleData={singleData}
        addEditModal={addEditModal}
        setAddEditModal={setAddEditModal}
      />
    </div>
  );
}
